<template>
  <div class="pt-1">

    <v-dialog
      v-model="showDialog"
      max-width="700px"
      persistent
    >
      <v-card class="pa-3">
        <v-form
          v-model="validated"
          ref="deviceEditForm">

          <!-- 基本情報 -->
          <v-text-field
            :label="$t('device.name')"
            v-model="edit.filtrationSystemName"
            required
            :rules="[v => !!v || $t('device.vali-device-name')]"
          ></v-text-field>

          <v-layout>
              <v-spacer></v-spacer>
              <v-btn
                flat
                @click.native="showDialog=false"
              >
                {{$t('btn.cancel')}}
              </v-btn>

              <v-btn
                color="primary"
                class="ml-4"
                @click.prevent="updateDevice"
                :disabled="(!validated || isRoot)"
              >
                <!-- {{$t('btn.save')}} -->
                {{editBtnName}}
              </v-btn>
          </v-layout>
          <!-- errors -->
          <div v-if="errorMessage" class="red--text">
            <strong>{{errorMessage}}</strong>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import http from '@/utils/http.js'
import utils from '@/utils/utils.js'

export default {
  data () {
    return {
      edit: {
        filtrationSystemId: '',
        filtrationSystemName: ''
      },
      validated: false,
      errorMessage: '',
      showDialog: false,
      isRoot: false,
      editBtnName: this.$t('btn.save') // 削除ボタン名
    }
  },
  methods: {
    init () {
      this.setExecBtnProperty()
    },
    startDialog (param) {
      // 一旦バリデーション等をリセット
      this.$refs.deviceEditForm.reset()
      // 値をバインド
      this.edit.filtrationSystemId = param.filtrationSystemId
      // エラーメッセージを初期化
      this.errorMessage = ''
      // 最新の情報を取得しセットする
      this.getSetDeviceInfomation(param.filtrationSystemId)
    },
    closeDialog (update) {
      // 更新のために発火
      if (update) {
        this.$emit('child-action')
      }
      this.showDialog = false
    },
    updateDevice () {
      this.errorMessage = ''
      const params = {
        filtrationSystemId: this.edit.filtrationSystemId,
        filtrationSystemName: this.edit.filtrationSystemName
      }
      http.request('post', '/service2/dashboard/api/FiltrationSystems/updateName', params)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('update organization data failed. (' + data.result + ')')
            return
          }
          // 成功
          this.closeDialog(true)
        })
        .catch(error => {
          console.log('error', error)
          this.closeDialog()
        })
    },
    getSetDeviceInfomation (filtrationSystemId) {
      http.request('get', '/service2/dashboard/api/FiltrationSystems/getFiltrationSystemName/' + filtrationSystemId)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get filtration system data failed. (' + data.result + ')')
            this.errorMessage = 'Failed to get Divice Information.'
            return
          }
          // 最新の値を反映
          this.edit.filtrationSystemId = data.device.filtrationSystemId
          this.edit.filtrationSystemName = data.device.filtrationSystemName
          // ダイアログを表示
          this.showDialog = true
        })
        .catch(error => {
          // TODO エラー処理
          this.errorMessage = 'Failed to get Divice Information.'
          console.log('error', error)
        })
    },
    // 保存ボタンの属性をセットする
    setExecBtnProperty () {
      this.isRoot = utils.isRoot(this.$store.getters.user.roles) // ルートかどうかを判定
      if (this.isRoot) {
        this.editBtnName = this.$t('aplix-use-only.btn.can-not-save')
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>

 </style>



// WEBPACK FOOTER //
// DeviceEditDialog.vue?992c1d90